import { useNavigation } from '@react-navigation/native';
import { Button } from 'aimo-ui';
import { FooterButtonContainer } from 'components/sheets/SheetLayout';
import { useParkingButtonLogic } from 'hooks/useParkingButton';
import React from 'react';
import { useParkingStore } from 'stores/parkingStore';
import { ParkNavProps } from 'types/navigation';
import { testIdentifiers } from 'utils/testIdentifiers';

const ParkingHereButton = () => {
  const { popTo } = useNavigation<ParkNavProps>();
  const { parkingConditions } = useParkingStore((state) => state);
  const { buttonText, disabled } = useParkingButtonLogic();

  const handleOnPress = () => {
    popTo('parkDetail', {
      parkingZoneUid: parkingConditions.selectedParkingZoneId,
    });
  };
  return (
    <FooterButtonContainer pt={24}>
      <Button
        buttonType="primary"
        size="l"
        text={buttonText}
        disabled={disabled}
        {...testIdentifiers('park-here-button')}
        onPress={handleOnPress}
      />
    </FooterButtonContainer>
  );
};

export default ParkingHereButton;
